import emitter, { EB_EVENT_NAME } from '@/utils/eventbus';
import { EventType, Handler } from 'mitt';

export interface PaymentContext {
  open: (depositStars?: number) => Promise<any>,
  close: () => void,
  onSuccessPayed: (callback: Handler) => void,
  onFailedPayed: (callback: Handler) => void,
  off: (evnetName: EventType, callback: Handler) => void,
}

export default function useDialog(): PaymentContext {
  // depositStars 为需要充值的star数量，如为0，则默认唤起第一个充值方案
  const open = async (depositStars?: number): Promise<any> => {
    emitter.emit(EB_EVENT_NAME.PAYMENT_DIALOG_OPEN, { depositStars });
  };

  const close = (): void => {
    emitter.emit(EB_EVENT_NAME.PAYMENT_DIALOG_CLOSE);
  };

  const onSuccessPayed = (callback: Handler): void => {
    emitter.on(EB_EVENT_NAME.PAYMENT_DIALOG_SUCCESS_PAYED, callback);
  };

  const onFailedPayed = (callback: Handler): void => {
    emitter.on(EB_EVENT_NAME.PAYMENT_DIALOG_FAILED_PAYED, callback);
  };

  const off = (evnetName: EventType, callback: Handler) => {
    if (!EB_EVENT_NAME.hasOwnProperty((evnetName as string))) {
      throw new Error(`Undefined deposity evnet: ${evnetName as string}`);
    }
    emitter.off(evnetName, callback);
  };

  return {
    open,
    close,
    onSuccessPayed,
    onFailedPayed,
    off,
  };
};
